const ArchivedFiles = () => import(/* webpackChunkName: "ArchivedFiles" */ "./pages/ArchivedFiles");
const ArchivedFilesOverview = () =>
    import(/* webpackChunkName: "ArchivedFilesOverview" */ "./pages/ArchivedFiles/ArchivedFilesOverview");

const pages = [
    {
        path: "/",
        redirect: "/archived-files",
    },
    {
        path: "/archived-files",
        name: "ArchivedFiles",
        component: ArchivedFiles,
        children: [
            {
                path: "",
                redirect: "/archived-files/overview",
            },
            {
                path: "overview",
                name: "ArchivedFilesOverview",
                component: ArchivedFilesOverview,
            },
        ],
    },
];

export { pages };
